import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../services/user/user.service';

@Component({
  selector: 'tgt-perfil',
  standalone: true,
  imports: [],
  templateUrl: './perfil.component.html',
  styleUrl: './perfil.component.scss',
})
export class PerfilComponent implements OnInit {
  iniciais: string = '';
  @Input() nome: string = '';
  @Input() size: 'middle' | 'small' = 'middle';
  @Input() border: 'true' | 'none' = 'true';
  @Input() icon: boolean = false;

  constructor(private readonly userService: UserService) {}

  ngOnInit(): void {
    this.buscarUsuarioPorID();
  }

  buscarUsuarioPorID() {
    this.iniciais = this.getInitials(this.userService.user?.name as string)
  }



  getInitials(name: string): string {
    const words = name.trim().split(/\s+/); // Divide o nome em palavras ignorando espaços extras
    const initials = words.map(word => word[0].toUpperCase()); // Pega a primeira letra de cada palavra
    return initials.slice(0, 2).join(''); // Junta as duas primeiras iniciais ou apenas uma se houver uma palavra
  }
}
